import { ANALYTICS_CHANNEL, useJqlPackageAnalytics } from '@atlaskit/jql-editor-common';
export var useJqlEditorAnalytics = function useJqlEditorAnalytics(analyticsSource) {
  return useJqlPackageAnalytics(analyticsSource, "@atlaskit/jql-editor", "5.0.7", ANALYTICS_CHANNEL);
};